import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import Button from '../Button/Button';
import styles from './HeroSection.module.scss';

import logo from '../../images/Timberland-Logo.svg';
import scrollIcon from '../../images/icons/Timberland-scroll.svg';

const HeroSection = ({
  heading,
  subHeading,
  imageFluid,
  children,
}) => {
  const wrapperStyles = [
    styles.wrapper,
  ].join(' ');

  return (
    <BackgroundImage
      Tag="section"
      className={wrapperStyles}
      fluid={imageFluid}
    >
      <div className={styles.backdrop} />
      <div className={styles.logoWrapper}>
        <img src={logo} alt="Timberland Logo" />
      </div>
      <div className={styles.content}>
        <h1 className={styles.heading}>
          Traditional Materials
          <br />
          <em>Modern Techniques</em>
        </h1>
        <h2 className={styles.subHeading}>
          Cornish Made Since 2008
        </h2>
        <Button onClick={() => navigate('/#contact')} label="Get in touch" cta />
        {children}
      </div>
      <div className={styles.scrollWrapper}>
        <img src={scrollIcon} alt="Scroll down" />
      </div>
    </BackgroundImage>
  );
};

HeroSection.propTypes = {
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  imageFluid: PropTypes.object.isRequired,
};

export default HeroSection;
